import { useQuery } from '@tanstack/react-query';
import { getSubscriptionPlans } from '@/services/subscription.service';
import { queryKeys } from '@/hooks/queries/keys';

export const useSubscriptionPlans = (options?: { enabled?: boolean }) => {
    return useQuery({
        queryKey: queryKeys.subscription.plans(),
        queryFn: getSubscriptionPlans,
        enabled: options?.enabled ?? true,
    });
};
